import { AppStore } from "@/store";
import { BASE_URL } from "../constants";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import { TokenData } from "@/types/auth";
import { useAuthActions } from "@/store/auth";

let store: AppStore | null = null;

export const injectStoreAxios = (_store: AppStore) => {
    if (!_store) {
        return;
    }
    store = _store;
}


const request = axios.create({ baseURL: BASE_URL, headers: { 'Content-Type': 'application/json' } });

request.interceptors.request.use((config) => {
    config.headers['Accept-language'] = 'pt-br';

    // const {setLoading} = useLayoutActions;
    // store?.dispatch(setLoading(true));

    if (config.url?.split('/').includes('auth') || config.url?.split('/').includes('public') || config.url?.split('/').includes('dados')) {
        return config;
    }

    if (store) {
        const token = store.getState().auth.accessToken;
        const { logout } = useAuthActions;
        if (!token) {
            store.dispatch(logout());
            config.cancelToken = new axios.CancelToken((cancel) => cancel('Token inválido'));
            return config;
        }
        if (token) {
            const tokenDecoded: TokenData = jwtDecode(token);
            const now = Date.now().valueOf() / 1000;
            if (tokenDecoded.exp < now) {
                store.dispatch(logout());
                config.cancelToken = new axios.CancelToken((cancel) => cancel('Token expirado'));
                toast.error('Sua sessão expirou, faça login novamente');
                return config;
            }
            config.headers['Authorization'] = `Bearer ${token}`;
        }
    }
    return config;
});


request.interceptors.response.use((response) => {
    // const {setLoading} = useLayoutActions;
    // store?.dispatch(setLoading(false));
    return response;
}, (error) => {
    // const {setLoading} = useLayoutActions;
    // store?.dispatch(setLoading(false));
    if (axios.isCancel(error)) {
        return Promise.reject(error);
    }
    return Promise.reject(error);
});


export default request;